class StoryTwo {
    constructor() {
        this.context = null;
        this.pageActive = {};
        $(".slide-area").slick({
            infinite: false,
            dots: false,
            fade: true,
            speed: 600,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            arrows: false,
            swipe: false
        });
        $(".slide-area1").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev01',
            nextArrow: '.area-next01'
        });
        $(".slide-area2").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev02',
            nextArrow: '.area-next02'
        });
        $(".slide-area3").slick({
            infinite: true,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            dots: true,
            fade: true,
            arrows: true,
            prevArrow: '.area-prev03',
            nextArrow: '.area-next03'
        });

        let currentAreaSlide = $('.slide-area').slick('slickCurrentSlide');
        $(".slide-wrap").removeClass("slider-pager1 slider-pager2 slider-pager3");
        $(".slide-wrap").addClass("slider-pager" + (currentAreaSlide + 1));
        $("a", ".pager-area li").removeClass("on");
        $("a", ".pager-area li").eq(currentAreaSlide).addClass("on");
        $(".btn-group li").hide();
        $(".btn-group li").eq(currentAreaSlide).show();
        $("a", ".pager-area li").click(function(e) {
            e.preventDefault();
            $(".slide-wrap").removeClass("slider-pager1 slider-pager2 slider-pager3");
            $("a", ".pager-area li").removeClass("on");
            $(".btn-group li").hide();
            $(this).addClass("on");
            let index = $(this).closest("li").index();
            $(".slide-wrap").addClass("slider-pager" + (index + 1));
            $(".btn-group li").eq(index).show();
            $(".slide-area").slick("slickGoTo", parseInt(index));
        });
    }

    start(page) {
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
    }

    reset(page) {
        this.pageActive[page] = false;
        this.context.removeClass('animate-in');
        this.context.addClass('animate-out');
        this.context.find('.active').removeClass('active');
    }

    storyTwo1() {
        this.context = $('.section-page__story2');
        this.context.addClass('animate-in');
        $(".slide-area").slick('refresh');
        $(".slide-area1").slick('refresh');
        $(".slide-area2").slick('refresh');
        $(".slide-area3").slick('refresh');
        $(window).resize();
        this.context.find('.obj3-2-tit').addClass('active');
        this.context.find('.obj3-2-txt1').addClass('active');
        this.context.find('.obj3-2-area').addClass('active');
    }
}

export default StoryTwo;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/page/storyTwo.js